const ITEMS = [
  "ONE POINT OF CONTACT",
  "CLEAR ESTIMATES BEFORE WORK BEGINS",
  "PHOTO-DOCUMENTED UPDATES",
  "RESIDENTIAL & COMMERCIAL",
  "DEPENDABLE SCHEDULING",
  "GREATER CINCINNATI & TRI-STATE",
  "QUALIFIED TRADE PROFESSIONALS",
];

export const Marquee = () => {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div className="relative border-y border-white/10 bg-[#12141C] py-5 overflow-hidden" data-testid="editorial-marquee">
      <div className="animate-marquee flex w-max items-center gap-10 whitespace-nowrap">
        {row.map((item, i) => (
          <span key={i} className="flex items-center gap-10">
            <span className="font-jbmono text-xs sm:text-sm uppercase tracking-[0.25em] text-slate-400">
              {item}
            </span>
            <span className="text-[#FF2A3B]">✦</span>
          </span>
        ))}
      </div>
    </div>
  );
};
